import React, { FC, useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'
import { theme, Text, Row, Space, Icon, Image, Spinner } from 'ui'
import { Button, Table, TableBody, TableCell, TableRow, TableHead, Checkbox, IconButton, TableContainer, Select, InputLabel, MenuItem } from '@material-ui/core'
import { Edit, Delete, Add, Close } from '@material-ui/icons'
import useStore, { budgetStore } from 'store'
import { observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'
import Import from 'assets/icons/Import.svg'
import Search from 'assets/icons/Search.svg'
import Export from 'assets/icons/Export.svg'
import DeleteIcon from 'assets/icons/ims/Delete.svg'
import Users from 'assets/icons/Users.svg'
import MemberIcon from 'assets/icons/MemberIcon.svg'
import UserIcon2 from 'assets/icons/UserIcon2.svg'
import EditIcon2 from 'assets/icons/ims/Edit2.svg'
import { TextField } from '@material-ui/core'
import UserNewModal from './UserNewModal'
import RemoveContactModal from './RemoveContactModal'
import ImportUsersModal from './ImportUsersModal'
import {
  fetchUserFamily,
  getFamilyRelations,
  fetchTags,
  fetchUser,
  fetchTagTypes,
  getOneHousehold,
  getAssignTags,
  User
} from './mockUsersApi'


const TableHeadStyled = styled(TableHead)`
  position: sticky;
  top: 0;
  z-index: 2;
  border-bottom: 0.909px solid #E2E8F0;
  background: rgba(241, 245, 249, 0.95);
`
const Wrap = styled.div`
  background-color:${theme.color.dialogBackground};
  @media (max-width: 768px) {
    background: rgba(0,0,0,0.05);
    padding: 1rem;
  }
  flex:1;
  padding: 1rem;
  overflow:auto;
`
const Container = styled.div`
  display: flex;
  height: 151.563px;
  flex-direction: column;
  align-items: flex-end;
  gap: 15.994px;
  flex-shrink: 0;
  align-self: stretch;
`
const ContactsTable = styled.div`
  margin-top: 20px;
  display: flex;
  flex: 1; 
  min-height: 0;
  padding: 0.909px;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 8px;
  border: 0.909px solid #E2E8F0;
  background: #FFF;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.10), 0 1px 2px -1px rgba(0, 0, 0, 0.10);
`
const Header = styled.div`
  display: flex;
  height: 85.781px;
  padding-right: 0;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;
`
const HLeftItem = styled.div`
  display: flex;  
  height: 85.781px;
  align-items: center;
  /*gap: 11.989px;*/
`
const HRightItem = styled.div`
  display: flex;
  height: 67.997px;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
`
const HRItemContainer = styled.div`
  display: flex;
  height: 67.997px;
  flex-direction: column;
  align-items: flex-start;
  gap: 7.997px;
`
const HRHeading1 = styled.div`
  display: flex;  
  padding-right: 0.506px;
  justify-content: center;
  align-items: center;
  color: #0F172A;
  font-family: Rubik;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 36px; 
`
const HRHeading2 = styled.div`
  color: #64748B;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; 
`
const StyledMemberIcon = styled(Image)`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`
const TableStyled = styled(Table)`
` 
const HLeftItemContainer1 = styled.div`
  display: flex;
  height: 85.781px;
  align-items: center;
  gap: 11.989px;
`
const HLeftItemInnerContainer1 = styled.div`
  display: flex;
  height: 85.781px;
  padding: 12.898px 20.909px 0.909px 20.909px;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  border-radius: 8px;
  border: 0.909px solid #E2E8F0;
  background: #FFF;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.10), 0 1px 2px -1px rgba(0, 0, 0, 0.10);
`
const HLeftItemInnerContainer1Content = styled.div`
  display: flex;
  height: 59.986px;
  align-items: center;
  gap: 11.989px;
  flex-shrink: 0;
  align-self: stretch;
`
const HLeftItemInnerContainer2 = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`
const HLeftItemInnerIconContainer1 = styled.div`
  display: flex;
  width: 35.994px;
  height: 35.994px;
  padding: 7.997px 7.997px 0 7.997px;
  flex-direction: column;  
  align-items: flex-start;
  border-radius: 30504000px;
  background: rgba(37, 99, 235, 0.10);
`
const HLeftItemInnerTextContainer1 = styled.div`
display: flex;
height: 59.986px;
flex-direction: column;
align-items: flex-start;
`
const StyledUserIcon2 = styled(Image)`
  height: 20px; 
  flex-shrink: 0;
  align-self: stretch;
`
const HLeftItemInnerText1Container1 = styled.div`
  color: #64748B;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`
const HLeftItemInnerText2Container1 = styled.div`
  color: #0F172A;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`
const HLeftItemInnerText3Container1 = styled.div`
  color: #64748B;
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`
const ActionsImage = styled(Image)`
  width: 16px;
  height: 16px;
`
const AddButton = styled(Button)`
  min-width: 200px;
  display: flex;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: #2563EB;
  color: #FFF;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.10), 0 1px 2px -1px rgba(0, 0, 0, 0.10);
`
const StyledIconButton = styled(IconButton)`
  padding: 8px;
`
const ImportButton = styled(Button)`
  display: flex;
  padding: 10px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border: 0.909px solid #E2E8F0;
  color: white;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  background: #00A63E;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.10), 0 1px 2px -1px rgba(0, 0, 0, 0.10);
`
const ImportExportImage = styled(Image)`
  width: 16px;
  height: 16px;
`
const SearchBar = styled.div`
  display: flex;
  width: 100%;
  height: 49.787px;
  padding: 15px 0px;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`
const SearchInput = styled(TextField)`
  width: 100%;
  border-radius: 8px;
  display: flex;
  
  background: none;
  align-items: center;
  border: none;
  gap: 10px;
  background: #FFF;
  .MuiInputBase-root {
    width: 100%;
  }
  .MuiOutlinedInput-notchedOutline{
    border: 0px;
  }
`
const TableContainerStyled = styled(TableContainer)`
  height: calc(100vh - 300px);
`
const TableCellRight = styled(TableCell)`
  body[dir="rtl"] &.MuiTableCell-root {
    text-align: right;
  }
`

const Test: FC = () => {
  const { t } = useTranslation(['budget'])
  const { imsUsersStore, user: userStore, orgs: orgStore } = useStore()
  const [openNewUserModal, setNewUserModal] = useState(false)
  const [openRemoveContactModal, setRemoveContactModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [disableEdit, setDisableEdit] = useState(false)
  const [search, setSearch] = useState('')
  const [removeUserId, setRemoveUserId] = useState(0)
  const [removeUserName, setRemoveUserName] = useState('')
  const [selectedUser, setSelectedUser] = useState(null)
  const [loadingUserId, setLoadingUserId] = useState<number | null>(null)
  const [openImportModal, setOpenImportModal] = useState(false)

  const [oldFamilyRelationIds, setOldfamilyRelation] = useState([])
  const [oldTagRelation, setOldRelation] = useState([])

  const ConfirmContactRemoveAction = (userId, userName) => {
    setRemoveContactModal(true)
    setRemoveUserId(userId)
    setRemoveUserName(userName)
  }

  const loadUsers = () => {
    setLoading(true)
    imsUsersStore.load(orgStore.currentOrgId)
      .then(() => setLoading(false))
  }

  useEffect(() => {
    loadUsers()
  }, [])

  const filteredUsers = useMemo(() => {
    if (!search) {
      return imsUsersStore.allUsers as any[]
    }

    const s = search.trim().toLowerCase()
    
    if (!s) return imsUsersStore.allUsers as any[]
    return (imsUsersStore.allUsers as any[]).filter(u =>
      u.fullName?.toLowerCase().includes(s) ||
      u.nickname?.toLowerCase().includes(s) ||
      u.israelId?.toLowerCase().includes(s) ||
      u.mainMobilePhone?.toLowerCase().includes(s) ||
      u.mainMobilePhone?.replace(/^\+972(\d{2})(\d+)/, '0$1-$2').toLowerCase().includes(s) ||
      u.mainMobilePhone?.replace(/^\+972(\d+)/, '0$1').toLowerCase().includes(s) ||
      u.email?.toLowerCase().includes(s)
    )
  }, [search, imsUsersStore.allUsers.length])

  const getUser = async (id: number) => {
    setLoadingUserId(id)
    const user = await fetchUser(id, orgStore.currentOrgId)
    const profile = await getOneHousehold(id, orgStore.currentOrgId)
    const family = await getFamilyRelations(id, orgStore.currentOrgId)
    const tags = await getAssignTags(id, orgStore.currentOrgId)
    setLoadingUserId(null)

    setDisableEdit(true)
    setNewUserModal(true)
    setUser(user.data, family, tags, profile.houseHold)
  }

  const addUser =  async () => {
    setNewUserModal(!openNewUserModal)
    setDisableEdit(false)
    setUser(null, null, null, null)
  }

  const editUser = async (id: number) => {
    setLoadingUserId(id)
    const user = await fetchUser(id, orgStore.currentOrgId)
    const profile = await getOneHousehold(id, orgStore.currentOrgId)
    const family = await getFamilyRelations(id, orgStore.currentOrgId)
    const tags = await getAssignTags(id, orgStore.currentOrgId)
    setLoadingUserId(null)

    if (Array.isArray(family.relations)) {
      setOldfamilyRelation(family.relations.map(item => item.id))
    }
 
    setOldRelation(tags.map(item => {
      return {
        tag: item.tag,
        tagTypeId: item.tagTypeId
      }
    }))
    
    setNewUserModal(true)
    setDisableEdit(false)
    setUser(user.data, family, tags, profile.houseHold)
  }

  const setUser = (user: any, family: any, tags: any, household: any) => {

    let formData = {
      id: user ? user.userId : 0,
      population: {
        firstName: user ? user.givenName : '',
        lastName: user ? user.familyName : '',
        middleName: user ? user.middleName : '',
        nickName: user ? user.nickName : '',
        identityNumber: user ? user.israeliId : '',
        city: user ? user.addressCity : '',
        street: user ? user.addressStreet : '',
        houseNumber: user ? user.addressHouseNumber : '',
        userTypes: tags ? tags.filter(t => t.tagTypeId == 1).map(item => ({ tagName: item.tag, tagTypeId: item.tagTypeId, action: "fromList" })) : [],
        nickname: user ? user.nickname : '',
        isDead: user ? user.dateOfDeath != null : false,
        birthDate: user ? user.dateOfBirth : null,
        isLocalMember: user ? user.mekomeEnabled : false,
        deathDate: user ? user.dateOfDeath : null,
        email: user ? user.email : '',
        phone: user ? user.mainMobilePhone : '',
        extraMobile: user ? user.secondaryMobilePhone : '',
        extraPhone: user ? user.otherPhone : '',
      },
      emergency: {
        contacts: []
      },
      family: {
        household: household ? {
          id: household.id,
          firstName: household.houseHoldName,
          createdAt: new Date(household.created)
        } : null,
        spouse: null,
        children: [] as any[]
      },
      contacts: {
        roles: tags ? tags.filter(t => t.tagTypeId == 2).map(item => ({ tagName: item.tag, tagTypeId: item.tagTypeId, action: "fromList" })) : [],
        tags: tags ? tags.filter(t => t.tagTypeId == 3).map(item => ({ tagName: item.tag, tagTypeId: item.tagTypeId, action: "fromList" })) : [],
        groups: [],
        permissions: {},
      },
    }

    if (user?.contactPerson1 || user?.contactPersonCellPhone1) {
      formData.emergency.contacts.push({
        mode: 'manual',
        name: user.contactPerson1,
        phone: user.contactPersonCellPhone1,
        address: ''
      })
    }
    
    if (user?.contactPerson2 || user?.contactPersonCellPhone2) {
      formData.emergency.contacts.push({
        mode: 'manual',
        name: user.contactPerson2,
        phone: user.contactPersonCellPhone2,
        address: ''
      })
    }

    if (family) {
      const parseMember = (relatedUserId: number) => {
        const member = family.familyMembers?.find(m => m.userId === relatedUserId)
        if (!member) return null

        const [firstName, ...rest] = (member.fullName || '').split(' ')
        return {
          mode: 'select' as const,
          id: member.userId,
          firstName,
          lastName: rest.join(' '),
          phone: member.mainMobilePhone || '',
          identityNumber: member.israelId || '',
        }
      }

      const spouseRelation = family.relations?.find(r => r.relationTypeId === 3)
      if (spouseRelation) {
        formData.family.spouse = parseMember(spouseRelation.relatedUserId)
      }

      formData.family.children = (family.relations?.filter(r => r.relationTypeId === 2) || [])
        .map(r => parseMember(r.relatedUserId))
        .filter(Boolean)
    }

    setSelectedUser(formData)
  }

  return (
    <Wrap>
        <UserNewModal
          disableEdit={disableEdit}
          oldFamilyRelationIds={oldFamilyRelationIds}
          oldTagRelation={oldTagRelation}
          open={openNewUserModal}
          onCloseModal={setNewUserModal}
          user={selectedUser}
          onSaved={() => loadUsers()}
        />
        <ImportUsersModal
          open={openImportModal}
          onClose={() => setOpenImportModal(false)}
          communityId={orgStore.currentOrgId}
          onImported={() => loadUsers()}
        />
        <RemoveContactModal
          open={openRemoveContactModal}
          closeModal={setRemoveContactModal}
          userId={removeUserId}
          userName={removeUserName}
          onDeleted={id => {
            imsUsersStore.removeUser(id)
            loadUsers()
          }}
        />
        <Container>
          <Header>
            <HRightItem>
              <HRItemContainer>
                <HRHeading1>
                  <Image src={Users} />
                  מערכת ניהול אוכלוסייה - {orgStore.currentOrg.name} 
                </HRHeading1> 
                <HRHeading2>
                  {filteredUsers.length} אנשי קשר
                </HRHeading2> 
              </HRItemContainer> 
            </HRightItem>

            <HLeftItem>
              <HLeftItemContainer1>
                 <HLeftItemInnerContainer2>
                  {/* <ExportButton startIcon={<ImportExportImage src={Export}/>}>ייצוא</ExportButton> */}
                  { <ImportButton onClick={() => setOpenImportModal(true)} startIcon={<ImportExportImage src={Import}/>}>ייבוא</ImportButton> }
                </HLeftItemInnerContainer2>

                <HLeftItemInnerContainer1>
                  <HLeftItemInnerContainer1Content>
                    <HLeftItemInnerIconContainer1>
                      <StyledUserIcon2 src={UserIcon2} />
                    </HLeftItemInnerIconContainer1>
                    <HLeftItemInnerTextContainer1>
                      <HLeftItemInnerText1Container1>משתמש מחובר</HLeftItemInnerText1Container1>
                      <HLeftItemInnerText2Container1>{`${userStore.user.given_name} ${userStore.user.nick_name ? '(' + userStore.user.nick_name + ')' : ''} ${userStore.user.family_name}`}</HLeftItemInnerText2Container1>
                      <HLeftItemInnerText3Container1>מנהל מערכת מקומי</HLeftItemInnerText3Container1>       
                    </HLeftItemInnerTextContainer1>
                  </HLeftItemInnerContainer1Content>
                </HLeftItemInnerContainer1>
              </HLeftItemContainer1>
            </HLeftItem>
          </Header>
          <SearchBar>
            <SearchInput
              role='search'
              placeholder={`חיפוש לפי שם, כינוי, ת.ז, נייד, דוא"ל או תגיות...`}
              variant="outlined"
              InputProps={{
                startAdornment: <Image src={Search} />,
              }}
              onChange={e => setSearch(e.target.value)}
            />
            <AddButton onClick={() => { addUser() }} startIcon={<Add/>}>הוספת איש קשר</AddButton>     
          </SearchBar>
        </Container> 

        <ContactsTable>
          <TableContainerStyled>
            <TableStyled stickyHeader>
                <TableHeadStyled>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCellRight>{`שם מלא`}</TableCellRight>
                    <TableCellRight>{`כינוי`}</TableCellRight>
                    <TableCellRight>{`מספר זהות`}</TableCellRight>
                    <TableCellRight>{`נייד`}</TableCellRight>
                    <TableCellRight>{`דוא״ל`}</TableCellRight>
                    <TableCell>{`פעולות`}</TableCell>
                  </TableRow>
                </TableHeadStyled>
                <TableBody>
                  {loading && (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        <Spinner />
                      </TableCell>
                    </TableRow>
                  )}

                  {!loading && filteredUsers.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={7}  rowSpan={3} align="center">
                        לא נמצאו אנשי קשר
                      </TableCell>
                    </TableRow>
                  )}

                  {!loading &&
                    filteredUsers.map(user => (
                      <TableRow key={user.id} hover={true} onClick={() => loadingUserId === null && getUser(user.userId)}>
                        <TableCell align='right'>
                            {user.mekomeEnabled && <StyledMemberIcon src={MemberIcon} />}
                        </TableCell>
                        <TableCellRight>{user.fullName}</TableCellRight>
                        <TableCellRight>{user.nickname}</TableCellRight>
                        <TableCellRight>{user.israelId}</TableCellRight>
                        <TableCellRight>{user.mainMobilePhone?.replace(/^\+972(\d{2})(\d+)/, '0$1-$2')}</TableCellRight>
                        <TableCellRight>{user.email}</TableCellRight>
                        <TableCell>
                          {loadingUserId === user.userId
                            ? <Spinner size={20} />
                            : <>
                                <StyledIconButton onClick={e => { e.stopPropagation(); editUser(user.userId) }}>
                                  <ActionsImage src={EditIcon2} />
                                </StyledIconButton>
                                <StyledIconButton onClick={e => { e.stopPropagation(); ConfirmContactRemoveAction(user.userId, user.fullName) }}>
                                  <ActionsImage src={DeleteIcon} />
                                </StyledIconButton>
                              </>
                          }
                        </TableCell>
                      </TableRow>
                  ))}
              </TableBody>
            </TableStyled>
</TableContainerStyled>
        </ContactsTable>   
    </Wrap>
  )
}


export default observer(Test)

